import React from 'react';
import DynamicPageSections from '../components/site/DynamicPageSections';
import ManagedInfoPageView from '../components/site/ManagedInfoPageView';
import { useSiteStructureSections } from '../hooks/useSiteStructureSections';
import { useManagedInfoPage } from '../hooks/useManagedInfoPage';

const AboutStatic: React.FC = () => (
  <div className="min-h-screen flex flex-col pb-16 md:pb-0 pt-16">
    <main className="flex-grow bg-gray-50">
      <section className="bg-gradient-to-r from-blue-600 to-purple-600 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">About NLS Store</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Your premier destination for fashion, electronics, and lifestyle products.
          </p>
        </div>
      </section>
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl text-center text-gray-600">
          <p>Content unavailable. Configure this page in Admin → About Us.</p>
        </div>
      </section>
    </main>
  </div>
);

const About: React.FC = () => {
  const { sections, ready } = useSiteStructureSections('/about');
  const { data, loading, error } = useManagedInfoPage('about');

  if (!ready || loading) {
    return (
      <div className="min-h-screen flex flex-col pt-20 pb-16 items-center justify-center bg-gray-50 text-gray-500 text-sm">
        Loading…
      </div>
    );
  }

  if (data && !error) {
    return <ManagedInfoPageView data={data} />;
  }

  if (sections.length > 0) {
    return (
      <div className="min-h-screen flex flex-col pb-16 md:pb-0 pt-16">
        <main className="flex-grow bg-gray-50">
          <DynamicPageSections sections={sections} />
        </main>
      </div>
    );
  }

  return <AboutStatic />;
};

export default About;


